import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

@Component({
  standalone: true,
  selector: 'empathy-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  imports: [CommonModule, FontAwesomeModule, MatIcon]
})
export class AvatarComponent {
  text = input<string>('');
  size = input<'sm' | 'md' | 'lg' | 'xl'>('md');
  shape = input<'round' | 'square'>('round');
  style = input<'auto' | 'basic' | 'transparent' | 'light'>('auto');
  faIcon = input<IconDefinition>();
  svgIcon = input<string>();

  initials$ = computed(() => this.getInitials(this.text()));
  paletteClass$ = computed(() => (this.style() === 'auto' ? this.getPaletteClass(this.text()) : ''));

  readonly sizeClasses$ = computed(() => {
    const sizeMap: Record<'sm' | 'md' | 'lg' | 'xl', { container: string; text: string }> = {
      sm: { container: 'avatar--sm', text: 'text__xs' },
      md: { container: '', text: 'text__sm' },
      lg: { container: 'avatar--lg', text: 'text__md' },
      xl: { container: 'avatar--xl', text: 'text__lg' }
    };
    return sizeMap[this.size()];
  });

  private getInitials(name: string): string {
    const parts = (name ?? '').trim().split(' ').filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return (name ?? '').substring(0, 2).toUpperCase();
  }

  private getPaletteClass(name: string): string {
    const classes = ['primary', 'accent', 'success', 'alert', 'warn', 'primary-alt', 'accent-alt', 'success-alt', 'alert-alt', 'warn-alt'] as const;
    let hash = 5381;
    for (let i = 0; i < name.length; i++) {
      hash = ((hash << 5) + hash) ^ name.charCodeAt(i);
    }
    return classes[Math.abs(hash) % classes.length];
  }
}
